import React from "react";

import Svg, { Path, G } from "components/Svg";

const Auto = props => (
	<Svg
		width={15 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 40.8 40.8"
	>
		<Path
			fill={props.fill || "white"}
			d="M20.4,0A20.4,20.4,0,1,0,40.8,20.4,20.486,20.486,0,0,0,20.4,0Zm0,37.8A17.4,17.4,0,1,1,37.8,20.4,17.413,17.413,0,0,1,20.4,37.8Z"
		/>
		<Path
			fill={props.fill || "white"}
			d="M30.1,11.1c-.1-.1-.2-.2-.4-.1-.2,0-.3.2-.4.4a24.313,24.313,0,0,1-5.6,7.2l-.5.4-.4-.5c-.2-.2-.4-.3-.6-.5l-.5-.3.2-.5a72.5,72.5,0,0,0,3-8.3.876.876,0,0,0-.5-1,12.208,12.208,0,0,0-10.6.7c-.1.1-.3.2-.3.3a.914.914,0,0,0,.3.5,24.8,24.8,0,0,1,5.6,7.7l.3.6-.5.3c-.2.1-.4.3-.6.4l-.4.4-.4-.4a60.666,60.666,0,0,0-7.3-5.5.83.83,0,0,0-1.2.2A13.765,13.765,0,0,0,7.2,23c0,.2.1.4.2.4a.6.6,0,0,0,.4-.1,26.44,26.44,0,0,1,9-2.7l.6-.1.1.6c0,.2.1.4.1.6l.2.5-.5.3A57.146,57.146,0,0,0,9.7,28a1.075,1.075,0,0,0-.2,1.4c1.7,2.4,4.9,4,8.6,4.3a.749.749,0,0,0,.5-.1.367.367,0,0,0,.1-.3,27.554,27.554,0,0,1,.3-9.1l.1-.6.6.1c.2,0,.4.1.6.1h.5l.1.5A61.731,61.731,0,0,0,23.2,33a1.089,1.089,0,0,0,1.3.7c4-1.2,6.2-3.2,7.4-6.5a.446.446,0,0,0,0-.5.758.758,0,0,0-.4-.2,25.325,25.325,0,0,1-8.3-3.3l-.6-.3.3-.6a4.875,4.875,0,0,0,.3-.7l.2-.5.6.1a82.982,82.982,0,0,0,8.7.5c.5,0,.8-.4.9-.9h0A9.848,9.848,0,0,0,30.1,11.1ZM22.3,21.5v.1a1.936,1.936,0,0,1-1.7,1h-.3a1.7,1.7,0,0,1-1.5-1.5h0v-.4a2.088,2.088,0,0,1,.8-1.6.1.1,0,0,0,.1-.1,1.689,1.689,0,0,1,1-.3,2.45,2.45,0,0,1,1.2.4l.1.1a1.816,1.816,0,0,1,.6,1.4C22.5,21,22.5,21.3,22.3,21.5Z"
		/>
        <Path
			fill={props.fill || "white"}
			d="M21.2,19.8a1.421,1.421,0,0,0-.6-.2,4.331,4.331,0,0,0-.5.1c-.1,0-.1.1-.2.1a1.234,1.234,0,0,0-.4.8h0a.6.6,0,0,0,.1.4.9.9,0,0,0,.6.6c.1,0,.2.1.3.1h.1a1.268,1.268,0,0,0,.9-.4c0-.1.1-.1.1-.2a.749.749,0,0,0,.1-.5,1.136,1.136,0,0,0-.3-.8C21.3,19.9,21.3,19.8,21.2,19.8Z"
		/>
	</Svg>
);

export default Auto;



// WEBPACK FOOTER //
// ./src/components/svgs/Fan/index.js